import React from 'react'
import { useState,useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import FilterFunctions from '../../../functions/public/filter';
import Bar from './bar';
import ProductGrid4 from '../../../components/public/pages/home/productGrid4';

const Products = ({searchParams}) => {
    const [products,setProducts] = useState([]);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const getmore_Products = ()=>{
      var category = searchParams.get('category') || "0";
      var subcategory = searchParams.get('subcategory') || "0";
      var brand = searchParams.get('brand') || "0";
      var condition = searchParams.get('condition') || "0";
      var color = searchParams.get('color') || "0";
      var size = searchParams.get('size') || 0;
      var orderby = searchParams.get('orderby') || 0;
      var value = searchParams.get('q') || "men"
      FilterFunctions.SearchProductGet({
          value: value,
          category:category,
          subcategory:subcategory,
          brand:brand,
          condition:condition,
          color:color,
          size:size,
          orderby:orderby,
          page:page
      },(data)=>{
          let prevPro = [];
          for (let index = 0; index < products.length; index++) {
            const element = products[index];
            prevPro.push(element);
          }
          for (let index = 0; index < data.responce.length; index++) {
              const element = data.responce[index];
              prevPro.push(element);
          }
          setProducts(prevPro);
          setPage(page+1);
          if(data.length === 0){
              setHasMore(false);
          }
          else{
              setHasMore(true);
          }
      })
  }
  useEffect(()=>{
      var category = searchParams.get('category') || "0";
      var subcategory = searchParams.get('subcategory') || "0";
      var brand = searchParams.get('brand') || "0";
      var condition = searchParams.get('condition') || "0";
      var color = searchParams.get('color') || "0";
      var size = searchParams.get('size') || 0;
      var orderby = searchParams.get('orderby') || 0;
      var value = searchParams.get('q') || "men"
      FilterFunctions.SearchProductGet({
          value:value,
          category:category,
          subcategory:subcategory,
          brand:brand,
          condition:condition,
          color:color,
          size:size,
          orderby:orderby,
          page:0
      },(data)=>{
          let prevPro = [];
          for (let index = 0; index < data.responce.length; index++) {
              const element = data.responce[index];
              prevPro.push(element);
          }
          setProducts(prevPro);
          setPage(1);
          if(data.responce.length === 0){
              setHasMore(false);
          }
          else{
              setHasMore(true);
          }
      })
  },[
      searchParams.get('category'),
      searchParams.get('subcategory'),
      searchParams.get('brand'),
      searchParams.get('condition'),
      searchParams.get('color'),
      searchParams.get('size'),
      searchParams.get('orderby'),
      searchParams.get('q')
  ])
  return (
    <div style={{ margin:"10px 40px" }}>
        <Bar baseUrl={`search/${searchParams.get('q')||""}`} searchParams={searchParams}/>
        <InfiniteScroll 
            dataLength={products.length}
            next={getmore_Products}
            hasMore={hasMore}
            loader={<h1></h1>}
        >
            <ProductGrid4 Products={products} Columns={5}/>   
        </InfiniteScroll>
    </div>
  )
}

export default Products
